import { paramCase } from 'src/utils/change-case';

import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: { details: `/product/${MOCK_ID}` },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: { details: `/post/${paramCase(MOCK_TITLE)}` },
  },
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
    updatePassword: `${ROOTS.AUTH}/update-password`,
    verify: `${ROOTS.AUTH}/verify`,
  },

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    report: `${ROOTS.DASHBOARD}/report`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
      course: `${ROOTS.DASHBOARD}/course`,
      home: `${ROOTS.DASHBOARD}/home`,
      chat: `${ROOTS.DASHBOARD}/chat`,
      account: `${ROOTS.DASHBOARD}/account`,
      faq: `${ROOTS.DASHBOARD}/faq`,
      faq_history: `${ROOTS.DASHBOARD}/faq_history`,
      feedback: `${ROOTS.DASHBOARD}/feedback`,
      privacy_policy: `${ROOTS.DASHBOARD}/privacy_policy`,
      cookie_policy: `${ROOTS.DASHBOARD}/cookie_policy`,
      terms_and_conditions: `${ROOTS.DASHBOARD}/terms_and_conditions`,
      faq_detail: `${ROOTS.DASHBOARD}/faq/faq_detail`,
      list: `${ROOTS.DASHBOARD}/list`,
      dashboard: `${ROOTS.DASHBOARD}/analytics_overview`,
      user_analytics: `${ROOTS.DASHBOARD}/user-analytics`,
      user_analytics_details: `${ROOTS.DASHBOARD}/user-analytics/details`,
      analytics_details: `${ROOTS.DASHBOARD}/analytics_overview/details`,
      addTrainer: `${ROOTS.DASHBOARD}/add_trainer`,
      trainerProfile: `${ROOTS.DASHBOARD}/trainer_profile`,
      addMember: `${ROOTS.DASHBOARD}/add_member`,
      trainers: `${ROOTS.DASHBOARD}/trainers`,
      members: `${ROOTS.DASHBOARD}/members`,
      perosnal_members: `${ROOTS.DASHBOARD}/personal_members`,
      admin_playlists: `${ROOTS.DASHBOARD}/admin_playlists`,
      admin_videos: `${ROOTS.DASHBOARD}/admin_videos`,
      admin_posts: `${ROOTS.DASHBOARD}/admin_posts`,
      admin_groups: `${ROOTS.DASHBOARD}/admin_groups`,
      news_letter: `${ROOTS.DASHBOARD}/news-letter`,
      faqs: `${ROOTS.DASHBOARD}/faqs`,
      faqsCategory: `${ROOTS.DASHBOARD}/faqs-category`,
      faqsSubCategory: `${ROOTS.DASHBOARD}/faqs-sub-category`,
      tickets: `${ROOTS.DASHBOARD}/support-center`,
      feedbackList: `${ROOTS.DASHBOARD}/feedback-list`,
      launch_list: `${ROOTS.DASHBOARD}/launch-list`,
      admin_referrals: `${ROOTS.DASHBOARD}/referral-system`,

      admin_messages: `${ROOTS.DASHBOARD}/admin_messages`,
      addVideo: `${ROOTS.DASHBOARD}/add_video`,
      playlist: (id) => `${ROOTS.DASHBOARD}/playlist/${id}`,
      post: (post_id) => `${ROOTS.DASHBOARD}/post/${post_id}`,
      addClass: `${ROOTS.DASHBOARD}/class`,
      classDetail: `${ROOTS.DASHBOARD}/class-detail`,
      reportlist: `${ROOTS.DASHBOARD}/reports/list`,
      moderationlist: `${ROOTS.DASHBOARD}/moderation/list`,
      memberProfile: `${ROOTS.DASHBOARD}/member_profile`,
      manageActivity: `${ROOTS.DASHBOARD}/manage-activity`,
      managePlate: `${ROOTS.DASHBOARD}/manage-plate`,
      viewProgram: `${ROOTS.DASHBOARD}/view-program`,
      viewPlate: `${ROOTS.DASHBOARD}/view-plate`,
      programMembers: `${ROOTS.DASHBOARD}/program-members`,
      workoutDiscussion: `${ROOTS.DASHBOARD}/workout-discussion`,
      NotesHistory: `${ROOTS.DASHBOARD}/notes-history`,
      exerciseNotesHistory: `${ROOTS.DASHBOARD}/exercise-notes-history`,
      setNotesHistory: `${ROOTS.DASHBOARD}/set-notes-history`,
      setDiscussion: `${ROOTS.DASHBOARD}/set-discussion`,
      plateMembers: `${ROOTS.DASHBOARD}/plate-members`,
      goalDetail: `${ROOTS.DASHBOARD}/goal-detail`,
      logNotes: `${ROOTS.DASHBOARD}/log-notes`,
      LogNotesHistory: `${ROOTS.DASHBOARD}/note-history`,
      activity_bundles: `${ROOTS.DASHBOARD}/activity-bundle`,
      individual_exercise: `${ROOTS.DASHBOARD}/individual-exercise`,
      meal: `${ROOTS.DASHBOARD}/meal`,
      food_scan: `${ROOTS.DASHBOARD}/food-scan`,
      log_history: `${ROOTS.DASHBOARD}/logs-history`,
      food_item_discussion: `${ROOTS.DASHBOARD}/food-item-discussion`,
      dish_item_discussion: `${ROOTS.DASHBOARD}/dish-item-discussion`,
      meal_discussion: `${ROOTS.DASHBOARD}/meal-discussion`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
    comingSoon: `${ROOTS.DASHBOARD}/coming-soon`,
    maintenance: `${ROOTS.DASHBOARD}/maintenance`,
    pricing: `${ROOTS.DASHBOARD}/pricing`,
    payment: `${ROOTS.DASHBOARD}/payment`,
    about: `${ROOTS.DASHBOARD}/about-us`,
    contact: `${ROOTS.DASHBOARD}/contact-us`,
    faqs: `${ROOTS.DASHBOARD}/faqs`,
    page403: `${ROOTS.DASHBOARD}/error/403`,
    page404: `${ROOTS.DASHBOARD}/error/404`,
    page500: `${ROOTS.DASHBOARD}/error/500`,
  },
};
